import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import DetailFieldText from 'fixedassets/components/detail/field/DetailFieldText';

const DetailFieldCurrency = ({ label, value, t }) => (
  <DetailFieldText
    label={label}
    value={value && typeof value === 'number' ? value.toFixed(2) : null}
  />
);

DetailFieldCurrency.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
  t: PropTypes.func.isRequired,
};

export default translate()(DetailFieldCurrency);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/field/DetailFieldNumber.js